import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { merge } from 'lodash';

import { RecursivePartial } from '@pimm/base';

export interface FormDataUserInformation {
  defaultSiteId: string;
  defaultLanguage: string;
  username: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  role: string;
  contactDetails: {
    email: string;
    mobile: string;
    phone: string;
  };
}

export const FormUserInformationSchema = yup.object({
  defaultSiteId: yup.string().required('account_settings:please_choose_default_site').default(''),
  defaultLanguage: yup.string().required('account_settings:please_choose_language').default(''),
  username: yup.string().required('account_settings:please_provide_username').default(''),
  jobTitle: yup.string().notRequired().default(''),
  firstName: yup.string().required('account_settings:please_provide_first_name').default(''),
  lastName: yup.string().required('account_settings:please_provide_last_name').default(''),
  role: yup.string().required('account_settings:please_select_role').default(''),
  contactDetails: yup.object({
    email: yup
      .string()
      .email('account_settings:please_provide_valid_email')
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'account_settings:please_provide_valid_email')
      .required('account_settings:please_provide_contact_email')
      .default(''),
    mobile: yup.string().nullable().optional(),
    phone: yup.string().nullable().optional(),
  }),
});

export type FormUserInformationProps = {
  defaultValues?: RecursivePartial<FormDataUserInformation>;
};

export const useFormUserInformation = (props?: FormUserInformationProps) => {
  return useForm({
    defaultValues: merge(FormUserInformationSchema.getDefault(), props?.defaultValues),
    mode: 'onChange',
    resolver: yupResolver(FormUserInformationSchema),
  });
};
